import { render, staticRenderFns } from "./handleConsultation.vue?vue&type=template&id=4d5a2dbe&scoped=true"
import script from "./handleConsultation.vue?vue&type=script&lang=js"
export * from "./handleConsultation.vue?vue&type=script&lang=js"
import style0 from "./handleConsultation.vue?vue&type=style&index=0&id=4d5a2dbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a2dbe",
  null
  
)

export default component.exports